/**
 * English translations for Help Widget System
 * Comprehensive tutorial and help center translations
 */

export const help = {
  // Widget UI
  'help.widget.title': 'Help Center',
  'help.widget.subtitle': 'Find answers quickly',
  'help.widget.search_placeholder': 'Search for help...',
  'help.widget.close': 'Close',
  'help.widget.back': 'Back',
  'help.widget.no_results': 'No results found',
  'help.widget.try_different_search': 'Try a different search',
  'help.widget.suggested_for_page': 'Suggested for this page',
  'help.widget.quick_actions': 'Quick actions',
  'help.widget.live_chat': 'Live chat',
  'help.widget.video_tutorials': 'Video tutorials',
  'help.widget.frequent_questions': 'Frequently asked questions',
  'help.widget.footer': 'Need more help? Contact contact@subvention360.com',

  // Categories
  'help.categories.dashboard': 'Dashboard',
  'help.categories.discovery': 'Discovery',
  'help.categories.search': 'Search',
  'help.categories.profile': 'Profile',
  'help.categories.calendar': 'Calendar',
  'help.categories.organization': 'Organization',
  'help.categories.all': 'All Articles',

  // Dashboard Articles
  'help.articles.getting_started.title': 'Getting Started',
  'help.articles.getting_started.description': 'Get started quickly with Subvention360',
  'help.articles.getting_started.content': 'Welcome to Subvention360! This guide helps you get started quickly. Begin by completing your profile, then explore available subsidies.',

  'help.articles.create_profile.title': 'Create a Profile',
  'help.articles.create_profile.description': 'Create and manage your company profiles',
  'help.articles.create_profile.content': 'A complete profile improves recommendation accuracy. Fill in your SIRET, industry sector, and key information.',

  'help.articles.understanding_dashboard.title': 'Understanding Dashboard',
  'help.articles.understanding_dashboard.description': 'Overview of your dashboard',
  'help.articles.understanding_dashboard.content': 'The dashboard displays your key statistics, recent subsidies, and recommended actions.',

  // Discovery Articles
  'help.articles.ai_discovery.title': 'AI Discovery',
  'help.articles.ai_discovery.description': 'How AI finds suitable grants for you',
  'help.articles.ai_discovery.content': 'Our AI analyzes your profile and automatically recommends the most relevant subsidies for your company.',

  'help.articles.match_scores.title': 'Match Scores',
  'help.articles.match_scores.description': 'Understanding relevance scores',
  'help.articles.match_scores.content': 'Match scores (0-100%) indicate how relevant a subsidy is to your profile. Higher scores mean better matches.',

  'help.articles.save_favorites.title': 'Save Favorites',
  'help.articles.save_favorites.description': 'Organize your favorite subsidies',
  'help.articles.save_favorites.content': 'Click the star icon to save a subsidy to your favorites for quick access.',

  // Search Articles
  'help.articles.search_filters.title': 'Search Filters',
  'help.articles.search_filters.description': 'Use filters to refine your results',
  'help.articles.search_filters.content': 'Use filters by region, sector, amount, and funding type to find exactly what you need.',

  'help.articles.save_search.title': 'Save a Search',
  'help.articles.save_search.description': 'Save your search criteria',
  'help.articles.save_search.content': 'Save your favorite search filters to reuse them quickly and receive alerts on new opportunities.',

  'help.articles.export_results.title': 'Export Results',
  'help.articles.export_results.description': 'Export your data to CSV or PDF',
  'help.articles.export_results.content': 'Export your search results in CSV or PDF format to share with your team or analyze offline.',

  // Profile Articles
  'help.articles.siret_guide.title': 'SIRET Guide',
  'help.articles.siret_guide.description': 'Everything about SIRET numbers',
  'help.articles.siret_guide.content': 'SIRET is your unique business identifier in France. It contains 14 digits and allows automatic retrieval of your official data.',

  'help.articles.profile_best_practices.title': 'Profile Best Practices',
  'help.articles.profile_best_practices.description': 'Optimize your profile for better results',
  'help.articles.profile_best_practices.content': 'A detailed and up-to-date profile ensures accurate recommendations. Regularly update your information and activities.',

  // Calendar Articles
  'help.articles.calendar_guide.title': 'Calendar Guide',
  'help.articles.calendar_guide.description': 'Manage your application deadlines',
  'help.articles.calendar_guide.content': 'The calendar displays all your application deadlines. Set up reminders to never miss a deadline.',

  // Alias for calendar (used in useContextualHelp)
  'help.articles.calendar.title': 'Calendar & Deadlines',
  'help.articles.calendar.description': 'Never miss an important deadline',

  'help.articles.notifications.title': 'Notifications',
  'help.articles.notifications.description': 'Configure your alerts and notifications',
  'help.articles.notifications.content': 'Receive email notifications for new opportunities, upcoming deadlines, and important updates.',

  // Organization Articles
  'help.articles.team_collaboration.title': 'Team Collaboration',
  'help.articles.team_collaboration.description': 'Work as a team on your applications',
  'help.articles.team_collaboration.content': 'Invite team members, assign roles, and collaborate effectively on your grant applications.',

  'help.articles.organization_roles.title': 'Organization Roles',
  'help.articles.organization_roles.description': 'Manage your team permissions',
  'help.articles.organization_roles.content': 'Define roles (Admin, Member, Reader) to control your team\'s access and permissions.',

  // Fallback Articles
  'help.articles.faq.title': 'Frequently Asked Questions',
  'help.articles.faq.description': 'Answers to common questions',
  'help.articles.faq.content': 'Browse our answers to the most frequently asked questions from our users.',

  'help.articles.contact_support.title': 'Contact Support',
  'help.articles.contact_support.description': 'Need additional help?',
  'help.articles.contact_support.content': 'Our support team is available to help. Contact us at contact@subvention360.com or via live chat.',

  // Alias for contact (used in useContextualHelp)
  'help.articles.contact.title': 'Contact Support',
  'help.articles.contact.description': 'Get help from our expert team',

  'help.articles.video_tutorials.title': 'Video Tutorials',
  'help.articles.video_tutorials.description': 'Learn by watching our videos',
  'help.articles.video_tutorials.content': 'Discover our video tutorials to learn visually how to use all platform features.',

  // Alias for videos (used in useContextualHelp)
  'help.articles.videos.title': 'Video Tutorials',
  'help.articles.videos.description': 'Learn with our step-by-step video guides',

  // Quick Actions
  'help.quick_actions.live_chat': 'Live Chat',
  'help.quick_actions.video_tutorials': 'Video Tutorials',
  'help.quick_actions.contact_support': 'Contact Support',
  'help.quick_actions.view_faq': 'View FAQ',

  // Error Messages
  'help.error.load_failed': 'Failed to load help',
  'help.error.retry': 'Retry',
  'help.error.article_not_found': 'Article not found',

  // Additional UI Elements
  'help.read_more': 'Read more',
  'help.related_articles': 'Related articles',
  'help.was_helpful': 'Was this article helpful?',
  'help.yes': 'Yes',
  'help.no': 'No',
  'help.thank_you': 'Thank you for your feedback!',
} as const;
